import AuthService, { GetAuthToken, handleRefreshToken, handleUnauthorized } from "../AuthService";
import AppSettings from "../AppSettings";
import constant from "../../Shell/Constant";
import { navigate } from "../../Shell/Navigation";
import rg4js from "raygun4js";
const hostName = window.location.hostname;
let baseUrl = AppSettings.serverUrl;

// Latency thresholds (ms): a Raygun event fires at each one a request is still pending past.
const SLOW_API_THRESHOLDS_MS = [5000, 10000, 15000];

// Arms timers before a fetch and returns a stop() that clears them once it settles.
function startSlowApiMonitor({ url, method }) {
    const startedAt = Date.now();
    const timers = SLOW_API_THRESHOLDS_MS.map((ms) =>
        setTimeout(() => {
            if (typeof rg4js !== "function") return;
            try {
                // Raygun's send requires an `error`; without it the event is dropped.
                rg4js("send", {
                    error: new Error(`Slow API: ${method} ${url} exceeded ${ms / 1000}s`),
                    tags: ["slow-api", `slow-api-${ms / 1000}s`],
                    customData: {
                        url,
                        method,
                        thresholdSeconds: ms / 1000,
                        elapsedMs: Date.now() - startedAt,
                        appVersion: AppSettings.dynamicCacheName,
                        path: window.location?.pathname,
                    },
                });
            } catch (e) {
                console.log("Slow API Raygun send failed:", e);
            }
        }, ms)
    );
    return () => timers.forEach(clearTimeout);
}

let GetRequest = async (endpoint, authorization = false, gsidRequired = false, AuthToken) => {
    let auth = AuthService.getAuthDataByName("gsid");
    let maxRetries = 4;

    for (let attempt = 0; attempt < maxRetries; attempt++) {
        const stopSlowMonitor = startSlowApiMonitor({ url: endpoint, method: "GET" });
        try {
            let headers = new Headers();
            // AuthToken just for the case of knock
            if (AuthToken) {
                let authToken = await AuthService.getAuthDataByName("AuthToken");
                headers.append('AuthToken', authToken);
            }

            // Set gsid if required
            if (gsidRequired) {
                headers.append('gsid', auth);
            }

            // Set Authorization and other headers if needed
            if (authorization) {
                let authToken = await GetAuthToken();
                headers.append('Authorization', authToken);
            }


            // Set common headers
            headers.append('Content-Type', 'application/json');
            headers.append('appVersion', AppSettings.dynamicCacheName);

            // Make the fetch request
            let response = await fetch(baseUrl + endpoint, {
                method: "GET",
                headers: headers
            });

            if (response.status === 401) {
                if (maxRetries === 4) {
                    // window.location.href = '/token-expired'
                    // navigate('/token-expired');
                    await handleRefreshToken();
                }
                continue; // Retry on unauthorized
            }

            return await response.json();

        } catch (err) {
            console.error(`Error fetching ${baseUrl + endpoint}:`, err);
        } finally {
            stopSlowMonitor();
        }
    }
};
let PostRequest = async (endpoint, data = null, authorization = false, gsidRequired = false, checkResponseType = false) => {
    let auth = AuthService.getAuthDataByName("gsid");
    var i = 0;
    while (i++ < 4) {
        const stopSlowMonitor = startSlowApiMonitor({ url: endpoint, method: "POST" });
        try {
            let headers = {}
            if (data && data?.isRegister) {
                headers['Authorization'] = data.token;
                headers['Content-Type'] = 'application/json';
                headers['appVersion'] = AppSettings.dynamicCacheName;
                if (gsidRequired) {
                    headers['gsid'] = auth
                }
            } else {
                if (gsidRequired) {
                    headers['gsid'] = auth
                }
                if (authorization) {
                    headers['Authorization'] = await GetAuthToken();
                    headers['Content-Type'] = 'application/json';
                    headers['appVersion'] = AppSettings.dynamicCacheName;
                }
            }
            var response = await fetch(baseUrl + endpoint, {
                method: "POST",
                headers: new Headers(headers),
                body: data ? JSON.stringify(data) : null
            })
            if (response.status === 401) {
                if (i === 4) {
                    // window.location.href = '/token-expired'
                    // navigate('/token-expired');
                    await handleRefreshToken();
                }
                continue; // Retry on unauthorized
            }
            else {
                if (checkResponseType) {
                    // if response is text
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.indexOf("application/json") !== -1) {
                        return await response.json();
                    } else {
                        return await response.text();
                    }
                }
                return await response.json();
            }
        } catch (err) {
            console.log(baseUrl + endpoint, err)
            // alert("something went wrong please refresh")
        } finally {
            stopSlowMonitor();
        }
    }
}

let PostFormsRequest = async (endpoint, data = null, authorization = false, gsidRequired = false) => {
    var i = 0;
    while (i++ < 4) {
        const stopSlowMonitor = startSlowApiMonitor({ url: endpoint, method: "POST" });
        try {
            let auth = AuthService.getAuthDataByName("gsid");
            let headers = authorization ? new Headers({ 'Authorization': await GetAuthToken(), 'appVersion': AppSettings.dynamicCacheName }) : {};

            if (gsidRequired) {
                headers.gsid = auth
            }

            console.log('request post object: ', {
                method: "POST",
                headers: headers,
                body: data ? data : null
            });
            for (var pair of data.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
            }
            var response = await fetch(baseUrl + endpoint, {
                method: "POST",
                headers: headers,
                body: data
            })
            if (response.status === 401) {
                if (i === 4) {
                    // window.location.href = '/token-expired'
                    // navigate('/token-expired');
                    await handleRefreshToken();
                }
                continue; // Retry on unauthorized
            }
            else {
                return await response.json();
            }
        } catch (err) {
            console.log(baseUrl + endpoint, err)
        } finally {
            stopSlowMonitor();
        }
    }
}
let AuthRequest = async (endpoint) => {
    const stopSlowMonitor = startSlowApiMonitor({ url: endpoint, method: "GET" });
    try {
        const response = await fetch(baseUrl + endpoint);
        return await response.json();
    } catch (error) {
        console.log(baseUrl + endpoint, error)
        return null;
    } finally {
        stopSlowMonitor();
    }
}



export { GetRequest, PostRequest, PostFormsRequest, AuthRequest }